import { Button, type ButtonAsLinkProps } from '@bennows/boows-react';
import type { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAssistant } from './AssistantProvider';

interface Props {
  readonly to: string;
  readonly variant?: 'link' | 'secondary';
  readonly label?: string;
  readonly children: ReactNode;
}

/** A link styled as a boows button that navigates inside the SPA (no page reload, the panel stays mounted; on a phone it closes). */
export function NavButton({ to, variant = 'link', label, children }: Props) {
  const navigate = useNavigate();
  const { phone, dismiss } = useAssistant();
  const props: ButtonAsLinkProps = {
    as: 'a',
    href: to,
    variant,
    size: 'sm',
    'aria-label': label,
    onClick: (event) => {
      event.preventDefault();
      navigate(to);
      // The phone overlay covers the page: leaving for the target closes it (the shell moves focus to the new page).
      if (phone) dismiss();
    },
  };
  return <Button {...props}>{children}</Button>;
}
